import React, { useEffect, useRef } from "react";
import includes from "lodash/includes";
import { useBlocker } from "react-router-dom";

const PROMPT_TEXT = "are you sure";

const getPromptMessage = (pathname) => {
  if (
    includes(pathname, "test-event") &&
    (includes(pathname, "room") || includes(pathname, "tasks"))
  ) {
    return true;
  }

  if (sessionStorage.getItem("taskInProgress")) {
    return PROMPT_TEXT;
  }

  return true;
};

const ExitTaskPrompt = () => {
  const promptMessageRef = useRef(true);

  const blocker = useBlocker(({ nextLocation }) => {
    const promptMessage = getPromptMessage(nextLocation.pathname);
    promptMessageRef.current = promptMessage;
    return promptMessage !== true;
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const promptMessage = getPromptMessage(globalThis.location.pathname);
      if (promptMessage !== true) {
        event.preventDefault();
        event.returnValue =
          typeof promptMessage === "string" ? promptMessage : "";
      }
    };

    globalThis.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      globalThis.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (blocker.state === "blocked") {
      const promptMessage = promptMessageRef.current;
      const confirmed =
        typeof promptMessage === "string"
          ? globalThis.confirm(promptMessage)
          : globalThis.confirm();

      if (confirmed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker]);

  return (
    <section className="exit-task-prompt">
      <div id="prompt" />
    </section>
  );
};

export default ExitTaskPrompt;
